import script from "./PasswordLinkRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordLinkRequest.vue?vue&type=script&setup=true&lang=js"

import "./PasswordLinkRequest.vue?vue&type=style&index=0&id=4c1cb5e3&lang=css"

const __exports__ = script;

export default __exports__